import PropTypes from "prop-types";

import { openNewTab } from "utils";
import { Button } from "components/Button";
import { LANDING_PAGE_URL } from "utils/constants";
import { paperPlaneIcon } from "assets/icons";
import { LimitedOfferModalContainer } from "./LimitedOfferModal.styles";

export const LimitedOfferModal = ({
  show,
  onHide,
  handleCancelSubscription,
}) => {
  const handleContactUs = () => {
    openNewTab(LANDING_PAGE_URL);
  };

  const onCancel = () => {
    onHide();
    handleCancelSubscription();
  };

  return (
    <LimitedOfferModalContainer show={show} onHide={onHide}>
      <div className="limited-offer-wrapper">
        <div className="offer-card">
          <div className="offer-title">
            <h2>Limited Offer</h2>
          </div>
          <p>Enjoy the same great benefits of your current plan</p>
          <div className="discount-wrapper">
            <h3>
              20<span>% off</span>
            </h3>
          </div>

          <h3>Use discount code</h3>
          <a href="#">
            50cancle50 <img src={paperPlaneIcon} />
          </a>
        </div>

        <Button
          onClick={handleContactUs}
          size="small"
          label="Contact Us"
          className="contact-us-btn"
        />
        <span className="cancel-sub" onClick={onCancel}>
          No, cancel my subscription
        </span>
      </div>
    </LimitedOfferModalContainer>
  );
};

LimitedOfferModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  handleCancelSubscription: PropTypes.func,
};
